import { gql, QueryHookOptions, useLazyQuery } from '@apollo/client';
import { RegistrationOptions } from '../../dto';

type Results = { generateRegistrationOptions: RegistrationOptions };

export const useGenerateRegistrationOptions = (options?: QueryHookOptions<Results>) => {
  const query = gql`
    query generateRegistrationOptions {
      generateRegistrationOptions {
        challenge
        rp {
          name
          id
        }
        user {
          id
          name
          displayName
        }
        pubKeyCredParams {
          type
          alg
        }
        timeout
        attestation
        authenticatorSelection {
          residentKey
          userVerification
        }
        extensions {
          credProps
        }
      }
    }
  `;

  return useLazyQuery(query, options);
};

export default useGenerateRegistrationOptions;
